<template>
  <div>
    <v-row no-gutters>
      <v-col :class="item.cssClass" :style="item.displayStyle">
        <v-row no-gutters
          ><v-col>
            <div
              v-if="heading.doc_id"
              :title="
                heading.title + ': Click to view ' + catalogueDocType.docType
              "
              @contextmenu="$emit('openDocActionsMenuContext', $event, heading)"
            >
              <DocSummary
                :doc_id="heading.doc_id"
                :text="heading.title"
                :searchTerms="searchTerms"
                @openDocument="$emit('openDocument', $event)"
                @copyDocument="$emit('copyDocument', $event)"
              ></DocSummary>
              <!-- <span :title="item.title">{{ item.title }}</span> -->
              <!-- <v-badge
                color="red"
                v-if="item.match_count && 1 === 0"
                :content="item.match_count"
                offset-y="10"
              >
                <v-icon
                  class="float-fight"
                  color="blue"
                  small
                  title="click to compare similar docments"
                  @click="$emit('showMatches', item)"
                  >mdi-content-duplicate</v-icon
                >
              </v-badge> -->
            </div>
            <v-checkbox
              v-else-if="heading.isSelectable"
              :label="heading.title"
              style="margin-top: 0; text-align: left"
              @click="$emit('selectJob', heading)"
            >
              <!-- v-model="item.selected" -->
            </v-checkbox>
            <div v-else-if="indentNode" style="position: relative">
              <div
                style="
                  margin-left: 50%;
                  border-left: 1px solid grey;
                  height: 10px;
                  width: 1px;
                  position: relative;
                  top: 0;
                "
              ></div>
              <cHierarchyNodeDisplay
                v-if="heading.node"
                :node="heading.node"
                :searchTerms="searchTerms"
                @action="$emit('doMenuAction', $event, heading, axis)"
              ></cHierarchyNodeDisplay>
            </div>
            <cHierarchyNodeDisplay
              v-else-if="heading.node"
              :node="heading.node"
              :displayPlain="axis !== 'horAxisSelected'"
              :displayPlainHeader="axis === 'horAxisSelected'"
              :customStyle="heading.displayStyle"
              :searchTerms="searchTerms"
              :hideNodeActions="hideNodeActions"
              @action="$emit('doMenuAction', $event, heading, axis)"
            ></cHierarchyNodeDisplay>
            <div v-else :title="heading.title" v-html="utils.highlightSearchTerms(heading.title, searchTerms)">
            </div> 
            <!-- {{ heading.title }} -->
            </v-col
          ></v-row
        >
        <!-- <v-row v-if="item.nestedColumns?.length" no-gutters>
          <v-col>
            <template v-for="(nc, nci) in item.nestedColumns">
              <span
                v-if="nc.valueDisplayType === 'chip'"
                :key="'hhc_nc' + nci"
                :class="nc.cssClass"
              ><v-icon small v-if="nc.valueIcon">{{nc.valueIcon}}</v-icon>
                {{ nc.title }}
              </span>
              <div v-else :key="'hhc_nc' + nci" :class="nc.cssClass">
                <v-icon small v-if="nc.valueIcon">{{nc.valueIcon}}</v-icon>
                {{ nc.title }}
              </div>
            </template>
          </v-col>
        </v-row> -->
      </v-col>
    </v-row>
    <v-row v-if="item.children?.length" no-gutters class="flex-nowrap">
      <template v-for="(c, ci) in item.children">
        <v-col :key="'ch' + ci" :style="c.colCSS" class="col-resizable">
            <div class="col-resize-handle" title="Drag to resize columns; double-click to reset"
              @click.stop
              @dblclick.stop="$emit('resetColumnWidth', 'H')"
              @pointerdown.stop.prevent="$emit('resizeColumn', $event, 'H', null, c.colWidth)"></div>
            <HierarchyViewColumnHeading
              :item="c"
              :axis="axis"
              :indentNode="indentNode"
              :catalogueDocType="catalogueDocType"
              :detailHeading="detailHeading"
              :searchTerms="searchTerms"
              :hideNodeActions="hideNodeActions"
              @openDocumentID="$emit('openDocumentID', $event)"
              @openDocActionsMenuContext="
                $emit('openDocActionsMenuContext', $event)
              "
              @showMatches="$emit('showMatches', $event)"
              @selectJob="$emit('selectJob', $event)"
              @doMenuAction="$emit('doMenuAction', $event)"
              @resizeColumn="$emit('resizeColumn', ...arguments)"
              @resetColumnWidth="$emit('resetColumnWidth', ...arguments)"
            ></HierarchyViewColumnHeading
          >
        </v-col>
      </template></v-row
    >
    <v-row v-else-if="detailHeading" no-gutters class="flex-nowrap">
      <v-col
        v-if="detailHeading.titles.length"
        :style="{ maxWidth: detailHeading.titleSectionWidth }"
      >
        <v-row no-gutters class="flex-nowrap">
          <v-col
            v-for="(c, ci) in detailHeading.titles"
            :key="'h' + ci"
            :style="{ minWidth: c.percent, maxWidth: c.percent }"
            :class="detailHeading.cssClass + ' col-resizable'" :title="c.name"
          >
            {{ c.visible ? c.name : "" }}
            <div v-if="c.key && (detailHeading.titles.length > 1 || detailHeading.measures.length)"
              class="col-resize-handle" title="Drag to resize; double-click to reset"
              @click.stop
              @dblclick.stop="$emit('resetColumnWidth', c.key)"
              @pointerdown.stop.prevent="$emit('resizeColumn', $event, c.key, c.px)"></div>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        v-if="detailHeading.measures.length"
        :style="detailHeading.measureSectionHeadingStyle"
        :class="detailHeading.cssClass"
      >
        <v-row no-gutters class="flex-nowrap">
          <v-col
            v-for="(m, mi) in detailHeading.measures"
            class="rm-header col-resizable"
            :key="'m' + mi"
            style="text-align: right"
            :title="m.title" :style="{ minWidth: m.percent, maxWidth: m.percent, paddingRight: detailHeading.measures.length > 1 && mi < detailHeading.measures.length - 1 ? '12px' : undefined }"
            >{{ m.title }}
            <div v-if="m.key" class="col-resize-handle" title="Drag to resize; double-click to reset"
              @click.stop
              @dblclick.stop="$emit('resetColumnWidth', m.key)"
              @pointerdown.stop.prevent="$emit('resizeColumn', $event, m.key, m.px)"></div>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import cHierarchyNodeDisplay from "@/components/hierarchy/cHierarchyNodeDisplay";
import DocSummary from "@/components/common/DocViewPopUp";
import utils from "@/common/utils.js";
export default {
  name: "HierarchyViewColumnHeading",
  props: {
    item: Object,
    indentNode: Boolean,
    axis: String,
    catalogueDocType: Object,
    cssClass: String,
    detailHeading: Object,
    searchTerms: { type: [], required: false },
    hideNodeActions: { type: Boolean, required: false },
  },
  data: function () {
    return {
      utils: utils,
    };
  },
  components: {
    cHierarchyNodeDisplay,
    DocSummary,
  },
  watch: {},
  computed: {
    heading() {
      return this.item.headerColumns[0];
    }
  },
  created: function () {},
  methods: {},
};
</script>
  <style scoped lang="scss">
.gridline {
  width: 1px;
  background-color: lightgray;
  position: relative;
  margin-bottom: -20px;
  margin-top: 12px;
}
.col-resizable {
  position: relative;
}
.col-resize-handle {
  position: absolute;
  top: 0;
  right: 0;
  width: 7px;
  height: 100%;
  cursor: col-resize;
  z-index: 5;
}
.col-resize-handle:hover {
  background-color: rgba(80, 179, 203, 0.4);
}
</style>